/** PalmTree screen copy. Merged into the Dutch app and the unit-test catalog. */
export const palmtreeUiMessages = {
  palmtree: {
    nav: {
      dashboard: "Dashboard",
      vandaag: "Vandaag",
      archive: "Archief",
      main: "Hoofdmenu",
      external: "%{label} (opent in nieuw tabblad)",
    },
    types: {
      person: "Persoon",
      company: "Bedrijf",
      partner: "Partner",
    },
    lists: {
      person: {
        label: "Contactpersonen",
        empty: "Nog geen contactpersonen. Voeg je eerste toe.",
        search: "Zoek contactpersonen...",
      },
      company: {
        label: "Bedrijven",
        empty: "Nog geen bedrijven. Voeg je eerste toe.",
        search: "Zoek bedrijven...",
      },
      no_results: "Geen resultaten.",
      last_note: "laatste notitie: %{text}",
      add_contact: "+ Contact",
    },
    contact: {
      new: "Nieuw contact",
      type_required:
        "Type is verplicht. Standaard = actieve lijst (hier: %{type}).",
      name: "Naam",
      name_placeholder: "Naam of bedrijfsnaam...",
      email: "Email",
      phone: "Telefoon",
      optional: "optioneel",
      required: "Verplicht",
      save: "Opslaan",
      cancel: "Annuleren",
      edit: "Bewerken",
      note: "Notitie",
      next_action: "Volgende actie",
      due_line: "%{when} • %{bucket}",
      no_open_action:
        "Geen open actie. Plan er één — elk contact heeft er maximaal één.",
      timeline: "Tijdlijn",
      field_type: "Type",
      field_company: "Bedrijf",
      field_role: "Rol",
      field_email: "Email",
      field_phone: "Tel",
      field_channel: "Voorkeurskanaal",
    },
    actions: {
      plan: "Plan actie",
      plan_plus: "+ Actie plannen",
      already: "Dit contact heeft al een volgende actie",
      planned: "Actie gepland",
      plan_title: "Actie plannen",
      done_toast: "Actie afgerond",
      done_error: "Afronden lukte niet. De actie staat er nog.",
      moved_toast: "Actie verschoven",
      moved_error: "Verschuiven lukte niet. De datum is niet gewijzigd.",
      move_title: "Actie verschuiven",
      new_date: "Nieuwe datum",
      done: "Afgerond",
      move: "Verschuiven",
    },
    vandaag: {
      title: "Vandaag",
      overdue: "Achterstallig",
      today: "Vandaag",
      empty: "Geen achterstallige of vandaag-acties.",
    },
    due: {
      overdue: "Achterstallig",
      today: "Vandaag",
      tomorrow: "Morgen",
      later: "Later",
    },
    dashboard: {
      attention: "Aandacht",
      empty:
        "Geen open acties. Plan een volgende actie vanaf een contactkaart.",
      note_suffix: " — laatste notitie: %{text}",
      today: "Vandaag",
      today_empty: "Niets voor vandaag.",
      all_today: "Alles vandaag →",
      news: "Nieuws",
      news_empty: "Nog geen nieuws.",
      news_error: "Nieuws laden lukte niet.",
      news_confirm: "Nog bevestigen",
      open_source: "Bron openen",
    },
    notes: {
      reject_not_saved: "De afwijzing is niet vastgelegd",
      ask: "Vraag voorstel",
      title: "Voorstel van Mistral",
      description:
        "Niets wordt opgeslagen tot je op Toepassen klikt. Vink uit wat je niet wilt overnemen.",
      loading: "Mistral maakt een voorstel…",
      no_summary: "Geen samenvatting.",
      changes: "Wijzigingen",
      no_field_changes: "Geen veldwijzigingen voorgesteld.",
      next_action: "Volgende actie",
      no_due: "geen datum",
      no_next: "Geen volgende actie voorgesteld.",
      existing: "Er staat al een open actie:",
      replace: "Vervang de open actie",
      complete_and_create: "Rond de open actie af en maak deze nieuwe aan",
      cancel: "Annuleren",
      apply: "Toepassen",
      saving: "Bezig…",
      field_status: "Status",
      field_role: "Rol",
      error_choice: "Kies of de open actie vervangen of afgerond wordt.",
      error_invalid:
        "Mistral gaf geen bruikbaar voorstel. Er is niets opgeslagen.",
      error_provider: "Mistral is nu niet bereikbaar. Er is niets opgeslagen.",
      error_disabled: "Voorstellen staan uit op de server.",
      error_empty: "Vink minstens één wijziging aan, of annuleer.",
      error_open: "Er is al een open actie. Kies vervangen of afronden.",
      error_status:
        "Dit contact is intussen gewijzigd. Vraag een nieuw voorstel.",
      error_generic: "Het voorstel lukte niet. Er is niets opgeslagen.",
    },
  },
};

export const dutchCrmMessages = {
  ra: {
    page: {
      dashboard: "Dashboard",
    },
    action: {
      save: "Opslaan",
      create: "Aanmaken",
      edit: "Bewerken",
      delete: "Verwijderen",
      cancel: "Annuleren",
    },
    auth: {
      sign_in: "Inloggen",
      logout: "Uitloggen",
      email: "E-mail",
      password: "Wachtwoord",
      create_account: "Account aanmaken",
    },
  },
  resources: {
    contacts: {
      name: "Contact |||| Contacten",
      fields: {
        first_name: "Voornaam",
        type: "Type",
        last_name: "Achternaam",
        title: "Rol",
        company_id: "Bedrijf",
        email_jsonb: "Email",
        email: "Email",
        phone_jsonb: "Tel",
        phone_number: "Tel",
        status: "Status",
        preferred_channel: "Voorkeurskanaal",
      },
      action: {
        new: "Nieuw contact",
        create: "Contact aanmaken",
        edit: "Contact bewerken",
      },
    },
    tasks: {
      name: "Actie |||| Acties",
      fields: {
        text: "Actie",
        due_date: "Vervaldatum",
        type: "Type",
        contact_id: "Contact",
      },
    },
    notes: {
      inputs: {
        add_note: "Nieuwe notitie...",
      },
      action: {
        add_this: "Notitie toevoegen",
      },
    },
  },
  "ra-supabase": {
    auth: {
      forgot_password: "Wachtwoord vergeten?",
    },
    reset_password: {
      forgot_password: "Wachtwoord vergeten?",
      forgot_password_details:
        "Vul je e-mail in om een resetlink te ontvangen.",
    },
    set_password: {
      new_password: "Kies een wachtwoord",
    },
  },
  crm: {
    action: {
      reset_password: "Wachtwoord resetten",
    },
    auth: {
      confirm_password: "Bevestig wachtwoord",
      sign_in_google_workspace: "Inloggen met Google Workspace",
      invalid_credentials: "E-mail of wachtwoord klopt niet.",
      generic_error: "Er ging iets mis. Probeer het opnieuw.",
      secure_access: "beveiligde toegang",
      placeholders: {
        email: "naam@bedrijf.nl",
      },
      login: {
        title: "Welkom terug",
        subtitle: "Log in om verder te gaan in PalmTree Hub",
        no_account: "Nog geen account?",
      },
      signup: {
        create_account: "Account aanmaken",
        email_taken: "Dit e-mailadres is al in gebruik.",
      },
      welcome_title: "Welkom bij PalmTree Hub",
    },
  },
  ...palmtreeUiMessages,
};
